import { createContext, Dispatch, SetStateAction } from 'react';
import {
  Listing,
  LISTING_GOING_CONCERN,
  ListingType,
} from '../../../../../models/Listing';
import { StripeError } from '@stripe/stripe-js';
import utils from 'utils';

type ListingContextProps = {
  listing: Partial<Listing>;
  listingFormValues: Partial<Listing>;
  completedSteps: number;
  listingType: ListingType;
  dealName: string;
  patchListingStep: (currentStep: string, listing: Partial<Listing>) => any;
  submitListing: (listing: Partial<Listing>) => any;
  setPayment: Dispatch<SetStateAction<() => Promise<StripeError>>>;
  setListing: Dispatch<SetStateAction<Partial<Listing>>>;
};

export default createContext<Partial<ListingContextProps>>({
  listing: null,
  listingFormValues: null,
  completedSteps: 0,
  listingType: LISTING_GOING_CONCERN,
  dealName: '',
  submitListing: utils.noop,
  patchListingStep: utils.noop,
  setPayment: utils.noop,
  setListing: utils.noop,
});
